(function () {
  'use strict';
  angular.module('dso')
    .component('corporateAddress', {
        bindings: {
          model: '=',
          readOnly: '@'
        },
        controller: ['States', function selectMemberController(States) {
          var ctrl = this;
          ctrl.states = States.query();
        }],
        templateUrl: '/js/dso/corporateAddress.html' + appVersion
      }
    );
})();
